<script>
import axios from 'axios'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import {
  getFirestore,
  collection,
  updateDoc,
  serverTimestamp,
  doc,
} from 'firebase/firestore/lite'
import { firebase } from '../../../../../firebase-int'
import CryptoJS from 'crypto-js'

const firestore = getFirestore(firebase)
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from 'vuelidate/lib/validators'

export default {
  page: {
    title: 'Edit Union',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      dismissSecs: 2,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      alertMessage: '',
      successStatus: true,
      processingData: false,

      dataLoading: false,

      pvtData: '',
      secret: '123#$%',
      encData: '',

      title: 'Edit Union',
      items: [
        {
          text: 'Gebi',
          href: '/',
        },
        {
          text: 'Union',
          href: '/Union',
        },
        {
          text: 'Edit Union: ' + this.$route.params.union.id,
          active: true,
        },
      ],
      union: [],
      federation: [],
      industry: [],
      region: [],
      unionName: this.$route.params.union.name,
      federationValue: this.$route.params.union.federation,
      industryValue: this.$route.params.union.industry,
      regionValue: this.$route.params.union.region,

      cbaDateSignedValue: this.$route.params.union.cbaDateSigned,
      cbaDateUpdatedValue: this.$route.params.union.cbaDateUpdated,
      dateEstablishedValue: this.$route.params.union.dateEstablished,

      form: {
        name: this.$route.params.union.name,
        description: this.$route.params.union.description,
        contactId: this.$route.params.union.contactId,
        contactNumber: this.$route.params.union.contactNumber,

        zoneSubcity: this.$route.params.union.zoneSubcity,
        woreda: this.$route.params.union.woreda,
        kebele: this.$route.params.union.kebele,
        houseNumber: this.$route.params.union.houseNumber,
        additionalInformation: this.$route.params.union.additionalInformation,

        notes: this.$route.params.union.notes,
        noOfMembersBeforeDebo: this.$route.params.union.noOfMembersBeforeDebo,
      },
      submit: false,
      submitted: false,
      formsubmit: false,
      typesubmit: false,

      calendarConfig: {
        wrap: true,
        dateFormat: 'd/m/Y',
        maxDate:'today'
      },
    }
  },
  validations: {
    form: {
      name: { required, minLength: minLength(2) },
      description: { required, minLength: minLength(5) },
      contactId: {
        required,
        minLength: minLength(20),
        maxLength: maxLength(20),
      },
      zoneSubcity: { required },
      woreda: { required },
      kebele: { required },
      houseNumber: { required },
      contactNumber: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(10),
        numeric,
      },
    },
    cbaDateSignedValue: { required },
    cbaDateUpdatedValue: { required },
    dateEstablishedValue: { required },
  },
  methods: {
    /**
     * Basic Form submit
     */
    handleSubmit(e) {
      this.submitted = true

      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.form.$pending || this.$v.form.$error || this.$v.$error) return

      if (!this.unionExists()) this.updateUnion()
      else {
        this.successStatus = false
        this.alertMessage =
          this.$i18n.t('page.union.unionExists')
        this.showAlert()
        this.processingData = false
      }
      //console.log('>>>>>>>>>>>>>>>>> union:' + this.unionExists())
    },

    unionExists() {
      return this.union.includes(this.form.name)
    },

    async updateUnion() {
      this.processingData = true
      try {
        const docRef = doc(firestore, 'union', this.$route.params.union.id)
        await updateDoc(docRef, {
          name: this.form.name,
          description: this.form.description,
          contactId: this.form.contactId,
          industry: this.industryValue,
          federation: this.federationValue,
          region: this.regionValue,
          zoneSubcity: this.form.zoneSubcity,
          woreda: this.form.woreda,
          kebele: this.form.kebele,
          houseNumber: this.form.houseNumber,
          additionalInformation: this.form.additionalInformation,
          contactNumber: this.form.contactNumber,

          notes: this.form.notes,
          noOfMembersBeforeDebo: this.form.noOfMembersBeforeDebo,
          cbaDateSigned: this.cbaDateSignedValue,
          cbaDateUpdated: this.cbaDateUpdatedValue,
          dateEstablished: this.dateEstablishedValue,

          updatedBy: this.$store.state.auth.currentUser.id,
          updated: serverTimestamp(),
        })
        //this.makeToast(false, "Document written with ID: ", docRef.id);
        this.successStatus = true
        this.dismissSecs = 2
        this.alertMessage = this.$i18n.t('page.union.contentUpdatedMessage') + docRef.id
        this.showAlert()
        console.log('Document written with ID: ', docRef.id)
        await this.addToLog(
          'union modified',
          this.$store.state.auth.currentUser.id,
          docRef.id
        )
        setTimeout(() => {
          this.$router.push({ name: 'Union' })
        }, 2000)
      } catch (e) {
        console.error('Error updating document: ', e)
        this.successStatus = false
        this.dismissSecs = 4
        this.alertMessage = this.$i18n.t('page.union.unableToUpdate')
        this.showAlert()
        this.processingData = false
      }
      //this.processingData=false;
    },

    // alert related methods
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },

    // encryption related methods
    encryptData(passwordData) {
      // return CryptoJS.AES.encrypt(JSON.stringify({ passwordData }), this.secret).toString();
      return CryptoJS.AES.encrypt(passwordData, this.secret).toString()
    },

    gotoUnions() {
      this.$router.push({ name: 'Union', params: { userId: '123' } })
    },

    async initializeData() {
      this.processingData = true
      this.dataLoading = true
      await axios
        .get('/api/gebi/union/all')
        .then((response) => {
          for (let doc of response.data) this.union.push(doc.name)
        })
      await axios
        .get('/api/gebi/industry/all')
        .then((response) => {
          for (let doc of response.data) this.industry.push(doc.name)
        })
      await axios
        .get('/api/gebi/federation/all')
        .then((response) => {
          for (let doc of response.data) this.federation.push(doc.name)
        })
      await axios
        .get('/api/gebi/region/all')
        .then((response) => {
          for (let doc of response.data) this.region.push(doc.name)
        })
      if (!this.industry.includes(this.industryValue))
        this.industryValue = this.industry[0]
      if (!this.federation.includes(this.federationValue))
        this.federationValue = this.federation[0]
      if (!this.region.includes(this.regionValue))
        this.regionValue = this.region[0]

      //remove current union name from union array
      this.removeUnionName()

      this.processingData = false
      this.dataLoading = false
    },

    removeUnionName() {
      //console.log(this.union);
      const index = this.union.indexOf(this.unionName)
      if (index > -1) {
        this.union.splice(index, 1)
      }
      //console.log(this.union);
    },
  },
  async mounted() {
    this.initializeData()
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="$t('page.union.titleEdit')" />
    <div class="row">
      <div class="col-lg-12">
        <b-alert
          v-if="successStatus"
          :show="dismissCountDown"
          dismissible
          fade
          variant="success"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
        >
          <p>{{ alertMessage }}</p>
        </b-alert>
        <b-alert
          v-else
          :show="dismissCountDown"
          dismissible
          fade
          variant="danger"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
        >
          <p>{{ alertMessage }}</p>
        </b-alert>
        <b-alert v-if="dataLoading" show dismissible fade variant="success">
          <p>{{ $t('page.union.loadingData') }}</p>
        </b-alert>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{ $t('page.union.unionInformation') }}</h4>
            <p class="sub-header">{{ $t('page.union.basicUnionInformation') }}</p>
            <form @submit.prevent="handleSubmit">
              <div class="form-group">
                <label for="name" :class="this.getStyle()">
                  {{ $t('page.union.unionName') }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="name"
                  v-model="form.name"
                  name="name"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.name.$error }"
                  type="text"
                />
                <div
                  v-if="submitted && $v.form.name.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.name.required"
                    >{{ $t('page.union.errorValueRequired') }}</span
                  >
                  <span v-if="!$v.form.name.minLength"
                    >{{ $t('page.union.mustBeTwoLong') }}</span
                  >
                </div>
              </div>
              <div class="form-group">
                <label for="description" :class="this.getStyle()">
                  {{ $t('page.union.unionDescription') }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.description"
                  type="text"
                  name="description"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.description.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.description.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.description.required"
                    >{{ $t('page.union.errorValueRequired') }}</span
                  >
                  <span v-if="!$v.form.description.minLength"
                    >{{ $t('page.union.bodyWarning') }}</span
                  >
                </div>
              </div>
              <div class="form-group">
                <label :class="this.getStyle()">
                  {{ $t('page.union.unionContactId') }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.contactId"
                  type="text"
                  name="contactId"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.contactId.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.contactId.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.contactId.required"
                    >{{ $t('page.union.errorValueRequired') }}</span
                  >
                  <span
                    v-if="
                      !$v.form.contactId.minLength ||
                      !$v.form.contactId.maxLength
                    "
                    >{{ $t('page.union.mustBeTwentyLong') }}</span
                  >
                </div>
              </div>
              <div class="form-group">
                <label :class="this.getStyle()">
                  {{ $t('page.union.unionPhoneNumber') }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.contactNumber"
                  type="number"
                  name="contactTelephone"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.contactNumber.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.contactNumber.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.contactNumber.required"
                    >{{ $t('page.union.errorValueRequired') }}</span
                  >
                  <span
                    v-if="
                      !$v.form.contactNumber.minLength ||
                      !$v.form.contactNumber.maxLength
                    "
                    >{{ $t('page.union.mustBeTenLong') }}</span
                  >
                </div>
              </div>
              <div class="form-group mt-3 mt-sm-0">
                <label :class="this.getStyle()" for="default">{{ $t('page.union.unionIndustry') }}</label>
                <multiselect
                  v-model="industryValue"
                  :options="industry"
                  :allow-empty="false"
                ></multiselect>
              </div>
              <div class="form-group mt-3 mt-sm-0">
                <label :class="this.getStyle()" for="default">{{ $t('page.union.unionFederation') }}</label>
                <multiselect
                  v-model="federationValue"
                  :options="federation"
                  :allow-empty="false"
                ></multiselect>
              </div>

              <div class="form-group mb-3">
                <label
                   :class="this.getStyle()"
                  >{{ $t('page.union.unionDateEstablished') }}
                  <span class="text-danger">*</span>
                </label>
                <flat-pickr
                  v-model="dateEstablishedValue"
                  :config="calendarConfig"
                  class="form-control"
                  name="dateEstablishedValue"
                  :class="{
                    'is-invalid': submitted && $v.dateEstablishedValue.$error,
                  }"
                ></flat-pickr>
                <div
                  v-if="submitted && !$v.dateEstablishedValue.required"
                  class="invalid-feedback"
                  >{{ $t('page.union.errorValueRequired') }}</div
                >
              </div>

              <div class="form-group">
                <label :class="this.getStyle()" for="noOfMembersBeforeDebo">
                  {{ $t('page.union.unionNumberOfMembers') }}
                </label>
                <input
                  id="noOfMembersBeforeDebo"
                  v-model="form.noOfMembersBeforeDebo"
                  name="noOfMembersBeforeDebo"
                  class="form-control"
                  type="number"
                   min="0" oninput="validity.valid||(value='');"
                />
              </div>
            </form>
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{ $t('page.union.unionAddressTitle') }}</h4>
            <p class="sub-header">{{ $t('page.union.enterUnionAddressInfo') }}</p>
            <form @submit.prevent="handleSubmit">
              <div class="form-group mt-3 mt-sm-0">
                <label :class="this.getStyle()" for="default">{{ $t('page.union.unionRegion') }}</label>
                <multiselect
                  v-model="regionValue"
                  :options="region"
                  :allow-empty="false"
                ></multiselect>
              </div>
              <div class="form-group">
                <label :class="this.getStyle()" for="zoneSubcity">
                  {{ $t('page.union.unionZone') }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="zoneSubcity"
                  v-model="form.zoneSubcity"
                  name="zoneSubcity"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.zoneSubcity.$error,
                  }"
                  type="text"
                />
                <div
                  v-if="submitted && !$v.form.zoneSubcity.required"
                  class="invalid-feedback"
                  >{{ $t('page.union.errorValueRequired') }}</div
                >
              </div>
              <div class="form-group">
                <label :class="this.getStyle()" for="woreda">
                  {{ $t('page.union.unionWoreda') }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="woreda"
                  v-model="form.woreda"
                  name="woreda"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.woreda.$error }"
                  type="text"
                />
                <div
                  v-if="submitted && !$v.form.woreda.required"
                  class="invalid-feedback"
                  >{{ $t('page.union.errorValueRequired') }}</div
                >
              </div>
              <div class="form-group">
                <label :class="this.getStyle()" for="kebele">
                  {{ $t('page.union.unionKebele') }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="kebele"
                  v-model="form.kebele"
                  name="kebele"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.kebele.$error }"
                  type="text"
                />
                <div
                  v-if="submitted && !$v.form.kebele.required"
                  class="invalid-feedback"
                  >{{ $t('page.union.errorValueRequired') }}</div
                >
              </div>
              <div class="form-group">
                <label :class="this.getStyle()" for="houseNumber">
                  {{ $t('page.union.unionHouseNumber') }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="houseNumber"
                  v-model="form.houseNumber"
                  name="houseNumber"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.houseNumber.$error,
                  }"
                  type="text"
                />
                <div
                  v-if="submitted && !$v.form.houseNumber.required"
                  class="invalid-feedback"
                  >{{ $t('page.union.errorValueRequired') }}</div
                >
              </div>
              <div class="form-group">
                <label :class="this.getStyle()" for="additionalInformation">
                  {{ $t('page.union.additionalInfo') }}
                </label>
                <input
                  id="additionalInformation"
                  v-model="form.additionalInformation"
                  name="additionalInformation"
                  class="form-control"
                  type="text"
                />
              </div>
            </form>
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1"
              >{{ $t('page.union.unionCBATitle') }}</h4
            >
            <p class="sub-header">{{ $t('page.union.enterCBAInfo') }}</p>
            <form @submit.prevent="handleSubmit">
              <div class="form-group mb-3">
                <label
                   :class="this.getStyle()"
                  >{{ $t('page.union.unionCBADateSigned') }}
                  <span class="text-danger">*</span>
                </label>
                <flat-pickr
                  v-model="cbaDateSignedValue"
                  :config="calendarConfig"
                  class="form-control"
                  name="cbaDateSignedValue"
                  :class="{
                    'is-invalid': submitted && $v.cbaDateSignedValue.$error,
                  }"
                ></flat-pickr>
                <div
                  v-if="submitted && !$v.cbaDateSignedValue.required"
                  class="invalid-feedback"
                  >{{ $t('page.union.errorValueRequired') }}</div
                >
              </div>
              <div class="form-group mb-3">
                <label :class="this.getStyle()"
                  >{{ $t('page.union.unionCBADateUpdated') }}
                  <span class="text-danger">*</span>
                </label>
                <flat-pickr
                  v-model="cbaDateUpdatedValue"
                  :config="calendarConfig"
                  class="form-control"
                  name="cbaDateUpdatedValue"
                  :class="{
                    'is-invalid': submitted && $v.cbaDateUpdatedValue.$error,
                  }"
                ></flat-pickr>
                <div
                  v-if="submitted && !$v.cbaDateUpdatedValue.required"
                  class="invalid-feedback"
                  >{{ $t('page.union.errorValueRequired') }}</div
                >
              </div>

              <div class="form-group">
                <label :class="this.getStyle()" for="notes">{{ $t('page.union.notes') }}</label>
                <input
                  id="notes"
                  v-model="form.notes"
                  name="notes"
                  class="form-control"
                  type="text"
                />
              </div>
            </form>
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <!--form @submit.prevent="handleSubmit">
                  <button v-if='!processingData' type="submit" class="btn btn-primary"
                    >Save</button>
                  <button v-else disabled  class="btn btn-primary"
                  >Save</button>
                  <a href="/member">
                  <button class="btn btn-secondary m-l-5 ml-1"
                    >Cancel</button></a>
            </form-->
            <form @submit.prevent="handleSubmit">
              <template>
                <b-button :disabled="processingData" type="submit" variant="primary"
                  ><i class="uil uil-down-arrow mr-1"></i>{{ $t('page.union.updateContentDetails') }}</b-button
                >
                <b-button
                  variant="light"
                  @click="gotoUnions"
                  style="margin-left: 10px"
                  >{{ $t('page.union.close') }}</b-button
                >
              </template>
            </form>
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
.btn {
  font-size: 1rem;
}
.btnSmallAm {
  font-size: 0.875rem;
}
.btnSmallEn {
  font-size: 0.675rem;
}
.lighterTextAm {
  font-weight: 500 !important;
  font-size: 1rem !important;
}
.lighterTextEn {
  font-weight: 600 !important;
  font-size: 0.875rem !important;
}
.lighterTextSmallAm {
  font-weight: 500 !important;
  font-size: 0.875rem !important;
}
.lighterTextSmallEn {
  font-weight: 600 !important;
  font-size: 0.675rem !important;
}
</style>
